module.exports = __webpack_public_path__ + "static/media/Forbidden-white Icon.fc2c220a.png";